import { http } from 'http';

export default {
  driverGuide: carRegistration => http.get(`/driversguide/services/${carRegistration}`)
};
